import { render } from "./indexsixbanner.vue?vue&type=template&id=74d4473c&scoped=true"
import script from "./indexsixbanner.vue?vue&type=script&lang=js"
export * from "./indexsixbanner.vue?vue&type=script&lang=js"

import "./indexsixbanner.vue?vue&type=style&index=0&id=74d4473c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d4473c"]])

export default __exports__